import React from 'react';

import { Typography } from '@mui/material';
import StatusIcon from '@sharedCR/common/StatusIcon';
import PropTypes from 'prop-types';

import { StatusEnum } from 'constants/status';

import { StatItemWrapper, textStyles } from './AusComparison.styles';

const StatItem = ({ status = StatusEnum.WARNING, text = '' }) => {
  return (
    <StatItemWrapper>
      <StatusIcon size={13} status={status} />
      <Typography sx={textStyles} variant="regular14">
        {text}
      </Typography>
    </StatItemWrapper>
  );
};

StatItem.propTypes = {
  status: PropTypes.string,
  text: PropTypes.string,
};

export default StatItem;
